"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Notifications = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _reselect = require("reselect");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _MarginAlert = require("./MarginAlert");
var _TransferRequests = require("./TransferRequests");
var _transfersTableSelectors = require("../../redux/selectors/transfersTableSelectors");
var _selectors = require("../../redux/margin/selectors");
require("./Notifications.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var createCls = (0, _cssClassesHelper.getBEMClasses)('notifications');
var components = [_TransferRequests.TransferRequest, _MarginAlert.MarginAlert];
var NotificationsList = function NotificationsList(_ref) {
  var notifications = _ref.notifications;
  if (!notifications.length) return null;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: createCls()
  }, notifications.map(function (notification) {
    var Component = components.find(function (component) {
      return component.isApplicable(notification);
    });
    return Component ? /*#__PURE__*/_react["default"].createElement(Component, {
      key: notification.id,
      item: notification
    }) : null;
  }));
};
var notificationsSelector = (0, _reselect.createSelector)(_selectors.marginNotificationsSelector, _transfersTableSelectors.formattedTransfersRequestSelector, function (marginNotifications, formattedTransfersRequest) {
  return marginNotifications.concat(formattedTransfersRequest);
});
var Notifications = exports.Notifications = (0, _reactRedux.connect)(function (state) {
  return {
    notifications: notificationsSelector(state)
  };
})(NotificationsList);